var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportedFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21.0006C16.9706 21.0006 21 16.9712 21 12.0006C21 7.03005 16.9706 3.00061 12 3.00061C7.02944 3.00061 3 7.03005 3 12.0006C3 16.9712 7.02944 21.0006 12 21.0006ZM12.6 7.64903C12.6 7.29092 12.3314 7.00061 12 7.00061C11.6686 7.00061 11.4 7.29092 11.4 7.64903V12.0202L10.6643 11.2251C10.4299 10.9719 10.0501 10.9719 9.81574 11.2251C9.58142 11.4783 9.58142 11.8889 9.81574 12.1421L11.5757 14.0441C11.8101 14.2973 12.1899 14.2973 12.4243 14.0441L14.1843 12.1421C14.4186 11.8889 14.4186 11.4783 14.1843 11.2251C13.9499 10.9719 13.5701 10.9719 13.3357 11.2251L12.6 12.0202V7.64903ZM8.2 14.4502C8.2 14.0921 7.93137 13.8018 7.6 13.8018C7.26863 13.8018 7 14.0921 7 14.4502V15.0842C7 15.5925 7.18683 16.0799 7.5194 16.4393C7.85196 16.7987 8.30302 17.0006 8.77333 17.0006H15.2267C15.697 17.0006 16.148 16.7987 16.4806 16.4393C16.8132 16.0799 17 15.5925 17 15.0842V14.4502C17 14.0921 16.7314 13.8018 16.4 13.8018C16.0686 13.8018 15.8 14.0921 15.8 14.4502V15.0842C15.8 15.2485 15.7396 15.4061 15.6321 15.5223C15.5246 15.6385 15.3787 15.7038 15.2267 15.7038H8.77333C8.62128 15.7038 8.47545 15.6385 8.36793 15.5223C8.2604 15.4061 8.2 15.2485 8.2 15.0842V14.4502Z",
    fill: "#26B4C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportedFileIcon);
export default __webpack_public_path__ + "static/media/exported-file_icon.c39ea564d6f29610bbb2299d3f7d180c.svg";
export { ForwardRef as ReactComponent };